const bootstrapRouter = [{
  path: "/",
  component: () => import("@/layout/Layout"),
  children: [
    {
      path: "/vue-bootstrap",
      name: "vue-bootstrap",
      component: () =>
        import("@/view/vue-bootstrap/VueBootstrap.vue"),
      children: [
        {
          path: "alert",
          name: "vue-bootstrap-alert",
          component: () => import("@/view/vue-bootstrap/Alert.vue"),
        },
        {
          path: "badge",
          name: "vue-bootstrap-badge",
          component: () => import("@/view/vue-bootstrap/Badge.vue"),
        },
        {
          path: "button",
          name: "vue-bootstrap-button",
          component: () => import("@/view/vue-bootstrap/Button.vue"),
        },
        {
          path: "button-group",
          name: "vue-bootstrap-button-group",
          component: () =>
            import("@/view/vue-bootstrap/ButtonGroup.vue"),
        },
        {
          path: "button-toolbar",
          name: "vue-bootstrap-button-toolbar",
          component: () =>
            import("@/view/vue-bootstrap/ButtonToolbar.vue"),
        },
        {
          path: "card",
          name: "vue-bootstrap-card",
          component: () => import("@/view/vue-bootstrap/Card.vue"),
        },
        {
          path: "carousel",
          name: "vue-bootstrap-carousel",
          component: () =>
            import("@/view/vue-bootstrap/Carousel.vue"),
        },
        {
          path: "collapse",
          name: "vue-bootstrap-collapse",
          component: () =>
            import("@/view/vue-bootstrap/Collapse.vue"),
        },
        {
          path: "dropdown",
          name: "vue-bootstrap-dropdown",
          component: () =>
            import("@/view/vue-bootstrap/Dropdown.vue"),
        },
        {
          path: "embed",
          name: "vue-bootstrap-embed",
          component: () => import("@/view/vue-bootstrap/Embed.vue"),
        },
        {
          path: "form",
          name: "vue-bootstrap-form",
          component: () => import("@/view/vue-bootstrap/Form.vue"),
        },
        {
          path: "form-checkbox",
          name: "vue-bootstrap-form-checkbox",
          component: () =>
            import("@/view/vue-bootstrap/FormCheckbox.vue"),
        },
        {
          path: "form-file",
          name: "vue-bootstrap-form-file",
          component: () =>
            import("@/view/vue-bootstrap/FormFile.vue"),
        },
        {
          path: "form-group",
          name: "vue-bootstrap-form-group",
          component: () =>
            import("@/view/vue-bootstrap/FormGroup.vue"),
        },
        {
          path: "form-input",
          name: "vue-bootstrap-form-input",
          component: () =>
            import("@/view/vue-bootstrap/FormInput.vue"),
        },
        {
          path: "form-radio",
          name: "vue-bootstrap-form-radio",
          component: () =>
            import("@/view/vue-bootstrap/FormRadio.vue"),
        },
        {
          path: "form-select",
          name: "vue-bootstrap-form-select",
          component: () =>
            import("@/view/vue-bootstrap/FormSelect.vue"),
        },
        {
          path: "form-textarea",
          name: "vue-bootstrap-form-textarea",
          component: () =>
            import("@/view/vue-bootstrap/FormTextarea.vue"),
        },
        {
          path: "image",
          name: "vue-bootstrap-image",
          component: () => import("@/view/vue-bootstrap/Image.vue"),
        },
        {
          path: "input-group",
          name: "vue-bootstrap-input-group",
          component: () =>
            import("@/view/vue-bootstrap/InputGroup.vue"),
        },
        {
          path: "jumbotron",
          name: "vue-bootstrap-jumbotron",
          component: () =>
            import("@/view/vue-bootstrap/Jumbotron.vue"),
        },
        {
          path: "layout-grid-system",
          name: "vue-bootstrap-layout-grid-system",
          component: () =>
            import("@/view/vue-bootstrap/LayoutGridSystem.vue"),
        },
        {
          path: "link",
          name: "vue-bootstrap-link",
          component: () => import("@/view/vue-bootstrap/Link.vue"),
        },
        {
          path: "list-group",
          name: "vue-bootstrap-list-group",
          component: () =>
            import("@/view/vue-bootstrap/ListGroup.vue"),
        },
        {
          path: "media",
          name: "vue-bootstrap-media",
          component: () => import("@/view/vue-bootstrap/Media.vue"),
        },
        {
          path: "modal",
          name: "vue-bootstrap-modal",
          component: () => import("@/view/vue-bootstrap/Modal.vue"),
        },
        {
          path: "nav",
          name: "vue-bootstrap-nav",
          component: () => import("@/view/vue-bootstrap/Nav.vue"),
        },
        {
          path: "navbar",
          name: "vue-bootstrap-navbar",
          component: () => import("@/view/vue-bootstrap/Navbar.vue"),
        },
        {
          path: "pagination",
          name: "vue-bootstrap-pagination",
          component: () =>
            import("@/view/vue-bootstrap/Pagination.vue"),
        },
        {
          path: "pagination-nav",
          name: "vue-bootstrap-pagination-nav",
          component: () =>
            import("@/view/vue-bootstrap/PaginationNav.vue"),
        },
        {
          path: "notify-popover",
          name: "vue-bootstrap-popover",
          component: () => import("@/view/vue-bootstrap/Popover.vue"),
        },
        {
          path: "notify-toasts",
          name: "vue-bootstrap-toasts",
          component: () => import("@/view/vue-bootstrap/Toasts.vue"),
        },
        {
          path: "notify-tooltip",
          name: "vue-bootstrap-tooltip",
          component: () => import("@/view/vue-bootstrap/Tooltip.vue"),
        },
        {
          path: "progress",
          name: "vue-bootstrap-progress",
          component: () =>
            import("@/view/vue-bootstrap/Progress.vue"),
        },
        {
          path: "progress-spinner",
          name: "vue-bootstrap-spinner",
          component: () => import("@/view/vue-bootstrap/Spinner.vue"),
        },
        {
          path: "table",
          name: "vue-bootstrap-table",
          component: () => import("@/view/vue-bootstrap/Table.vue"),
        },
        {
          path: "tabs",
          name: "vue-bootstrap-tabs",
          component: () => import("@/view/vue-bootstrap/Tabs.vue"),
        },
      ],
    }
  ],
}];

export default bootstrapRouter;